import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2541fea5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tuto-step" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title" }

import { useI18n } from 'vue-i18n'
import { onMounted, onUnmounted, ref } from 'vue'
import lottie, { AnimationItem } from 'lottie-web'
import Viewport from '@/store/modules/Viewport'
import FrontResources from '@/core/FrontResources';


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props

const { t } = useI18n()



const anim = ref(null)
const animationItem = ref<AnimationItem>(null)

onMounted(()=> {
  if(!Viewport.isMobile) {
    animationItem.value = lottie.loadAnimation({
      container: anim.value as Element,
      renderer: 'svg',
      autoplay: true,
      loop: true,
      animationData: FrontResources.Group.get(`tutorial-${props.id}`),
      // animationData: require(`@/assets/lottie/tutorial-${props.id}.json`),
    })
  }
})

onUnmounted(() => {
  animationItem?.value?.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(`tuto.desktop.${__props.id}.title`)), 1)
        ]),
        _createElementVNode("div", {
          class: "figure",
          ref_key: "anim",
          ref: anim
        }, null, 512)
      ])
    ]),
    _: 1
  }))
}
}

})